<template>
  <rect
    x="13.6562"
    y="0.929688"
    width="2"
    height="18"
    rx="1"
    transform="rotate(45 13.6562 0.929688)"
    fill="#3769D6"
  />
  <circle opacity="0.5" cx="12.5" cy="12.5" r="2.5" fill="#3769D6" />
  <circle opacity="0.5" cx="3.5" cy="3.5" r="2.5" fill="#3769D6" />
</template>
